/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Mic_Blocked_Other_2Inputs */



/**
* | output |
* | --- |
* | "Allow the microphone." |
*
* @param {Practice_Session_Mic_Blocked_Other_2Inputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_mic_blocked_other_2 = /** @type {((inputs?: Practice_Session_Mic_Blocked_Other_2Inputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Mic_Blocked_Other_2Inputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Sta de microfoon toe.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Autorisez le micro.")
	return /** @type {LocalizedString} */ ("Allow the microphone.")
});